import { useContext, useEffect, useRef } from 'react'
import styles from './styles.module.css'
import { Input, Checkbox } from '../../../components/ModalInputs'
import { StudentsContext } from '../../../utils/context'
import { arrayForSelect } from '../../../utils/arrayForSelect'
import CustomSelect from '../../../components/CustomSelect'
import { useDispatch, useSelector } from 'react-redux'
import { getHealthgroup } from '../../../actions/medCenter/healthGroups'
import { getPhysicalGroups } from '../../../actions/physicalGroup'
import { getLibraryDeskNumbers } from '../../../actions/library'

// Группа крови: 1=O(I), 2=A(II), 3=B(III), 4=AB(IV)
const bloodTypes = [
  { value: '', name: '' },
  { value: 1, name: 'O(I)' },
  { value: 2, name: 'A(II)' },
  { value: 3, name: 'B(III)' },
  { value: 4, name: 'AB(IV)' },
]

// Резус-фактор: -1=отрицательный, 0=не указан, 1=положительный
const rhFactors = [
  { value: '', name: '' },
  { value: 0, name: 'не указан' },
  { value: 1, name: 'Rh+' },
  { value: -1, name: 'Rh-' },
]

export default function Health() {
  const dispatch = useDispatch()

  const { allForms, addMode, studentTabData, updateInitialValues } = useContext(StudentsContext)
  const { healthgroup } = useSelector(state => state.directoryMedCenter)
  const { list: physicalGroupList } = useSelector(state => state.physical_group)
  const { deskNumbers } = useSelector(state => state.library)

  const { values, setFieldValue, setValues } = allForms

  const { health } = studentTabData || {}

  const lastSyncedRef = useRef(null)

  const handleHealthChange = (e) => {
    const { name, value, type, checked } = e.target
    setFieldValue(`health.${name}`, type === 'checkbox' ? checked : value)
  }

  const setHealthFieldValue = (name, value) => {
    setFieldValue(`health.${name}`, value)
  }

  useEffect(() => {
    dispatch(getHealthgroup())
    if (!physicalGroupList?.length) dispatch(getPhysicalGroups())
    if (!deskNumbers?.length) dispatch(getLibraryDeskNumbers())
  }, [dispatch]) // eslint-disable-line

  useEffect(() => {
    const healthJson = JSON.stringify(health)
    if (!addMode && health && lastSyncedRef.current !== healthJson) {
      lastSyncedRef.current = healthJson
      setValues(prev => ({
        ...prev,
        health: { ...health }
      }))
      if (updateInitialValues) {
        updateInitialValues('health', health)
      }
    }
  }, [health, addMode, setValues, updateInitialValues])

  return (
    <div className={styles.tabWrapper}>
      <div className={styles.qualificationForm}>
        <div className={styles.inputsRow}>
          <CustomSelect
            title='Группа здоровья'
            valuesName='healthgroup_id'
            value={(values.health || {}).healthgroup_id || ''}
            options={arrayForSelect(healthgroup || [], 'name', 'hid')}
            setFieldValue={setHealthFieldValue}
          />
        </div>
        <div className={styles.inputsRow}>
          <CustomSelect
            title='Группа крови'
            valuesName='blood_type'
            value={(values.health || {}).blood_type || ''}
            options={arrayForSelect(bloodTypes, 'name', 'value')}
            setFieldValue={setHealthFieldValue}
          />
          <CustomSelect
            title='Резус-фактор'
            valuesName='rh'
            value={(values.health || {}).rh ?? ''}
            options={arrayForSelect(rhFactors, 'name', 'value')}
            setFieldValue={setHealthFieldValue}
          />
        </div>
        <div className={styles.inputsRow}>
          <Input
            label='Индекс физического здоровья'
            name='physical_health_index'
            value={(values.health || {}).physical_health_index || ''}
            onChange={handleHealthChange}
          />
        </div>
        <div className={styles.inputsRow}>
          <Input
            label='Уровень физической подготовленности'
            name='level_physical_fitness'
            value={(values.health || {}).level_physical_fitness || ''}
            onChange={handleHealthChange}
          />
        </div>
        <div className={styles.inputsRow}>
          <CustomSelect
            title='Физкультурная группа'
            valuesName='physicalgroup_id'
            value={(values.health || {}).physicalgroup_id || ''}
            options={arrayForSelect(physicalGroupList || [], 'name', 'id')}
            setFieldValue={setHealthFieldValue}
          />
          <CustomSelect
            title='Номер парты'
            valuesName='desk_number'
            value={(values.health || {}).desk_number || ''}
            options={arrayForSelect(deskNumbers || [], 'name', 'name')}
            setFieldValue={setHealthFieldValue}
          />
        </div>
        <div className={styles.inputsRow}>
          <Input
            label='Рекомендации врача по СанПиНу'
            name='doctors_recommendation'
            value={(values.health || {}).doctors_recommendation || ''}
            onChange={handleHealthChange}
            style={{ width: '100%' }}
          />
        </div>
        <div className={styles.inputsRow}>
          <Input
            style={{ width: '200px' }}
            label='Индекс массы тела'
            name='body_mass_index'
            value={(values.health || {}).body_mass_index || ''}
            onChange={handleHealthChange}
            disabled
          />
        </div>
        <div className={styles.inputsRow}>
          <Checkbox
            label='Оценивает блюда столовой'
            name='is_dish_assessment'
            checked={(values.health || {}).is_dish_assessment || false}
            onChange={handleHealthChange}
          />
          <Checkbox
            label='Рекомендации по питанию'
            name='food_recomendations'
            checked={(values.health || {}).food_recomendations || false}
            onChange={handleHealthChange}
          />
        </div>
      </div>
    </div>
  )
}
